/**
 * 判断图片是否为 Data URI 格式？
 * @param image 图片地址
 */
export function isDataURL(image) {
  return /^data:image\/(?:jpe?g|png|svg\+xml);base64,/.test(String(image));
}